import dayjs from 'dayjs';
import i18n from 'i18n';
import {isNumber} from 'lodash';
import moment from 'moment';
import {FOREVER_TIMESTAMP} from './constants';

const DATE_PARAM_TEXT = 'DATE';
const DATE_PARAM = '<' + DATE_PARAM_TEXT + '>';
const DATE_FORMAT = 'MMM DD, YYYY HH:mm:ss';

export const hasDateParam = (str: string) => str && str.indexOf(DATE_PARAM) >= 0;

export const parseLocalDateTime = (value: moment.MomentInput, locale: string) =>
   value && moment(value, undefined, locale).format(DATE_FORMAT);

export const formatDateTime = (date?: dayjs.ConfigType) =>
   dayjs(date || undefined).format('YYYY-MMM-DD ddd HH:mm');

export const formatDateTimeStrict = (date?: dayjs.ConfigType) =>
   date ? dayjs(date).format('YYYY-MMM-DD HH:mm:ss') : '';

export const formatDate = (date?: dayjs.ConfigType) =>
   dayjs(date || undefined).format('YYYY-MMM-DD');

export const formatTime = (date?: dayjs.ConfigType) => dayjs(date || undefined).format('HH:mm:ss');

export const formatDateOrNever = (date?: dayjs.ConfigType) => {
   if (isNumber(date) && date === FOREVER_TIMESTAMP) {
      return i18n.t('Never');
   }
   return dayjs(date).format('MMM DD, YYYY');
};

export const convertDaysToSeconds = (days: number) => days * 24 * 60 * 60;

export function timeTo(time: Date | string, endTime?: Date | string) {
   const elapsed = dayjs(endTime).diff(dayjs(time), 'seconds');
   // console.debug(elapsed);
   if (elapsed < 3600) {
      return new Date(elapsed * 1000).toISOString().substr(14, 5);
   }
   return new Date(elapsed * 1000).toISOString().substr(11, 8);
   // const mins = Math.floor(elapsed / 60);
   // const secs = Math.floor(elapsed - mins * 60);
   // return `${mins}:${secs}`;
}

export const elapsedFormatted = (from: dayjs.ConfigType, to: dayjs.ConfigType) => {
   const elapsed = dayjs(to).diff(dayjs(from), 'seconds', true);

   return secondsToHms(elapsed);
};

export function secondsToHms(d: number) {
   d = Number(d);

   const lessThanASecond = d > 0 && d < 1;
   if (lessThanASecond) return '< 1 sec';

   const h = Math.floor(d / 3600);
   const m = Math.floor((d % 3600) / 60);
   const s = Math.floor((d % 3600) % 60);

   const hDisplay = h > 0 ? h + (h === 1 ? ' hr, ' : ' hrs, ') : '';
   const mDisplay = m > 0 ? m + (m === 1 ? ' min, ' : ' mins, ') : '';
   const sDisplay = s >= 0 ? s + (s === 1 ? ' sec' : ' secs') : '';
   return hDisplay + mDisplay + sDisplay;
}

export const calcNextTime = (
   period: 'NONE' | 'THREE_MONTH' | 'SIX_MONTH' | 'ONE_YEAR',
   _date: Date | number | string
) => {
   let date = dayjs(_date);

   switch (period) {
      case 'THREE_MONTH':
         date = date.add(3, 'months');
         break;
      case 'SIX_MONTH':
         date = date.add(6, 'months');
         break;
      case 'ONE_YEAR':
         date = date.add(12, 'months');
         break;
   }

   return formatDate(date.toDate());
};

export const daysTo = (expirationDate: dayjs.ConfigType) => {
   const daysLeft = dayjs(expirationDate).diff(dayjs(), 'days');
   //   console.debug('license expire', daysLeft);
   return daysLeft; // > 0 && daysLeft <= daysBefore;
};

export const isNotifiable = (daysTo: number, notifyPeriod: number) => {
   return daysTo >= 0 && daysTo <= notifyPeriod;
};
